import { useFormContext } from "react-hook-form";
import { FieldInput } from "@/components/businesses/fields/FieldInput";
import { BusinessLogoUploader } from "@/components/businesses/BusinessLogoUploader";
import type { WizardValues } from "./schema";

interface BasicsStepProps {
  businessId?: string;
}

export const BasicsStep = ({ businessId }: BasicsStepProps) => {
  const { watch, setValue } = useFormContext<WizardValues>();
  const logoUrl = watch("logoUrl");

  return (
    <div className="space-y-4">
      <BusinessLogoUploader
        businessId={businessId}
        currentUrl={logoUrl}
        onUrlChange={(url) =>
          setValue("logoUrl", url ?? undefined, { shouldDirty: true })
        }
      />
      <FieldInput<WizardValues>
        name="businessName"
        label="Business name"
        required
        placeholder="e.g. Sunrise Care"
      />
      <div className="grid md:grid-cols-2 gap-3">
        <FieldInput<WizardValues>
          name="nameEn"
          label="Name (English)"
          required
        />
        <FieldInput<WizardValues>
          name="nameMl"
          label="Name (Malayalam)"
          required
        />
      </div>
      <FieldInput<WizardValues>
        name="descriptionEn"
        label="Description (English)"
        textarea
        rows={3}
      />
      <FieldInput<WizardValues>
        name="descriptionMl"
        label="Description (Malayalam)"
        textarea
        rows={3}
      />
    </div>
  );
};
